import { getGoalListState } from '../goalListUtils';
import { calculateProgressFromSubGoals } from '../goalProgressUtils';

test('uses nested children without losing task or milestone data and preserves progress', () => {
  const children = [
    { id: 's1', metric_type: 0, progress: 80, goal_weight: 25, tasks: [{ id: 't1' }] },
    { id: 's2', metric_type: 2, progress_value: 50, metric_start_range: 0,
      metric_end_range: 100, goal_weight: 75, milestones: [{ id: 'm1' }] }
  ];
  const state = getGoalListState({ goals: [{ id: 'g1', sub_goals: children }] });
  expect(state.subGoalsByGoalId.g1).toBe(children);
  expect(calculateProgressFromSubGoals(state.subGoalsByGoalId.g1)).toBe(57.5);
});

test('counts standalone and owned cascade goals once, excluding other employees', () => {
  const own = { id: 'linked', is_goal_owner: true, goal_weight: '60', sub_goals: [] };
  const state = getGoalListState({
    goals: [{ id: 'standalone', goal_weight: 40 }],
    cascading_goals: [{ goals_for_cascading: [own,
      { id: 'other', is_goal_owner: false, goal_weight: 90 }] },
    { goals_for_cascading: [own] }]
  });
  expect(state.totalWeight).toBe(100);
  expect(state.userGoalList.map(goal => goal.id)).toEqual(['standalone', 'linked']);
  expect(state.subGoalsByGoalId.linked).toEqual([]);
});

test('empty responses clear previous goals and children', () => {
  expect(getGoalListState({ message: 'No Goal Present' })).toEqual({
    goalList: [], cascadingGoalList: [], subGoalsByGoalId: {}, userGoalList: [], totalWeight: 0
  });
});

test('team view hides Draft and unset standalone states but preserves linked goals', () => {
  const approved = { id: 'approved', goal_progress_state_id: 'a', goal_progress_states: 'Approved' };
  const draft = { id: 'draft', goal_progress_state_id: 'd', goal_progress_states: 'Draft' };
  const data = {
    goals: [approved, draft, { id: 'unset', goal_progress_state_id: null }],
    cascading_goals: [{ goals_for_cascading: [draft] }]
  };
  expect(getGoalListState(data, { teamView: true }).goalList).toEqual([approved]);
  expect(getGoalListState(data, { teamView: true }).cascadingGoalList).toBe(data.cascading_goals);
  expect(getGoalListState(data).goalList).toBe(data.goals);
});
